import { render, staticRenderFns } from "./editStore.vue?vue&type=template&id=12ede96f&scoped=true&"
import script from "./editStore.vue?vue&type=script&lang=js&"
export * from "./editStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ede96f",
  null
  
)

export default component.exports